export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			IsOpen: false,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "peopleToggle";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.$el.addEventListener("click", (e) => {
				e.preventDefault();
				const article = e.target.closest("article");
				const content = article.querySelector(".people-content");

				if (article.classList.contains("active")) {
					article.classList.remove("active");
					this.$el.querySelector(".people__expanded-bio").innerHTML =
						"";
					return;
				} else {
					this.$el.querySelector(".people__expanded-bio").innerHTML =
						content.innerHTML;
				}
				const articles = this.$el.querySelectorAll("article");
				articles.forEach((article) => {
					article.classList.remove("active");
				});
				article.classList.add("active");
				// if (this.isClosing || !this.IsOpen) {
				// 	this.open();
				// } else if (this.isExpanding || this.IsOpen) {
				// 	this.shrink();
				// }

				// get the index of article, and figure out which grid "row" it's in. there are 3 grid items per row on desktop, and 2 items per row on mobile
				const index = Array.prototype.indexOf.call(
					article.parentNode.children,
					article
				);
				const row = Math.floor(index / 3);
				const rowMobile = Math.floor(index / 2);
				// const rowItems = Array.prototype.slice.call(
				// 	article.parentNode.children,
				// 	row * 3,
				// 	row * 3 + 3
				// );
				// const rowItemsMobile = Array.prototype.slice.call(
				// 	article.parentNode.children,
				// 	row * 2,
				// 	row * 2 + 2
				// );
				// console.log(row, rowItems, rowItemsMobile);

				const outStyle = `--bioRow: ${row + 2}; --bioRowMobile: ${
					rowMobile + 2
				};`;
				this.$el.setAttribute("style", outStyle);
			});

			// this.summary = this.$el.querySelector("summary");
			this.content = this.$el.querySelector(".people__expanded-bio");
			this.animation = null;
			this.isClosing = false;
			this.isExpanding = false;
			// this.summary.addEventListener("click", (e) => this.onClick(e));
		}
	}

	onClick(e) {
		e.preventDefault();
		this.content.style.overflow = "hidden";
		if (this.isClosing || !this.IsOpen) {
			this.open();
		} else if (this.isExpanding || this.IsOpen) {
			this.shrink();
		}
	}

	shrink() {
		this.isClosing = true;
		const startHeight = `${this.content.offsetHeight}px`;
		const endHeight = `0px`;
		if (this.animation) {
			this.animation.cancel();
		}

		this.animation = this.content.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 150,
				easing: "ease-out",
			}
		);

		this.animation.onfinish = () => this.onAnimationFinish(false);
		this.animation.oncancel = () => (this.isClosing = false);
	}

	open() {
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.IsOpen = true;
		window.requestAnimationFrame(() => this.expand());
	}

	expand() {
		this.isExpanding = true;
		const startHeight = `${this.content.offsetHeight}px`;
		const endHeight = `${this.content.offsetHeight}px`;

		if (this.animation) {
			this.animation.cancel();
		}

		this.animation = this.content.animate(
			{
				height: [startHeight, endHeight],
			},
			{
				duration: 200,
				easing: "ease-out",
			}
		);
		this.animation.onfinish = () => this.onAnimationFinish(true);
		this.animation.oncancel = () => (this.isExpanding = false);
	}

	onAnimationFinish(open) {
		this.IsOpen = open;
		this.animation = null;
		this.isClosing = false;
		this.isExpanding = false;
		this.content.style.height = this.content.style.overflow = "";
	}
}
